/** Copie robuste (Clipboard API, repli textarea masquée) — ne lève jamais. */
export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* permission refusée */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select(); const ok = document.execCommand("copy"); document.body.removeChild(ta); return ok;
  } catch { return false; }
}
